export enum CashbackCampaignPaymentStatus {
  Pending,
  Paid,
  Rejected,
  Failed,
  InProgress,
  Mix,
}

export enum CashbackTransactionStatus {
  Settled,
  Rejected,
  Failed,
  InProgress,
}

export interface SubCashbackCommissionReport {
  login: number;
  calculationDate: Date;
  periodStart: Date;
  periodEnd: Date;
  volumeUsd: number;
  volumeLots: number;
  commission: number;
  cashbackAmount: number;
  transactionStatus: number;
}

export interface CashbackCommissionReport {
  calculationDate: Date;
  campaignName: string;
  periodStart: Date;
  periodEnd: Date;
  partnershipCodes: string[];
  volumeUsd: number;
  volumeLots: number;
  commission: number;
  campaignPaymentStatus: number;
  paidCashback: number;
  pendingCashback: number;
  rejectedCashback: number;
  failedCashback: number;
  subCashbackCommissionReportViewModels: SubCashbackCommissionReport[];
}

export const columnsInEn = [
  'Calculation Date',
  'Calculation Period',
  'Campaign Name',
  'Partnership',
  'Volume (USD)',
  'Volume (Lots)',
  'Commission (USD)',
  'Cashback Paid (USD)',
  'Cashback Pending (USD)',
  'Cashback Rejected (USD)',
  'Cashback Failed (USD)',
];

export const dialogColumnsInEn = ['Client Trading Account', 'Calculation Date', 'Calculation Period', 'Campaign Name', 'Volume (USD)', 'Volume (Lots)', 'Commission (USD)', 'Cashback (USD)', 'Cashback Status'];
